import ProfileDetails from "../../stories/profile";
import styles from "./profile.module.scss";
import ProfileHeader from "../../stories/profile/profile-header";
import { useLogout } from "../../hooks/react-query/auth/useLogout";
import ProfileHeaderBar from "./profile-header-bar";
import ButtonC from "../../stories/common/button";
import { useNavigate } from "react-router-dom";
const Profile = () => {
  const navigate = useNavigate();
  const logoutMutation: any = useLogout(
    (data) => {
      // setLoading(false);
      // setVisibleLogout(false);
      localStorage.removeItem("user-detail");
      localStorage.removeItem("salesforceAccessToken");
      localStorage.removeItem("layout");
      localStorage.removeItem("showMap");
      localStorage.removeItem("filter");
      localStorage.removeItem("map-persist");
      navigate("/");
    },
    (error) => {
      localStorage.removeItem("user-detail");
      localStorage.removeItem("salesforceAccessToken");
      localStorage.removeItem("layout");
      localStorage.removeItem("showMap");
      localStorage.removeItem("filter");
      localStorage.removeItem("map-persist");
      navigate("/");
      // console.log("error", error);
    }
  );
  const handleLogout = async () => {
    (await logoutMutation).mutate();
  };

  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj && JSON.parse(userObj ?? "");
  
  return (
    <div className={styles.profile}>
      <div className={styles.content}>
        <ProfileHeaderBar />
        <ProfileHeader
          user={{
            url: userDetail?.banner_photo_url,
            firstName: userDetail?.name.split(" ")[0],
            lastName: userDetail?.name.split(" ")[1]
          }}
        />
        <ProfileDetails
          user={{
            email: userDetail?.username,
            firstName: userDetail?.name.split(" ")[0],
            lastName: userDetail?.name.split(" ")[1],
            number: userDetail?.number
          }}
        />
        <ButtonC
          btnType="border"
          type="submit"
          tabIndex={7}
          size="small"
          className={styles.logoutBtn}
          label={"Logout"}
          onClick={handleLogout}
        />
        {/* <button className={styles.logoutBtn}>
          <span className={styles.logoutBtnText}>Logout</span>
        </button> */}
      </div>
    </div>
  );
};

export default Profile;
